import { type ReactNode, useMemo } from "react";

import { ClientOnly } from "@/components/ui/ClientOnly";
import { ScaledIframe } from "@/components/ui/ScaledIframe/ScaledIframe";
import { WithPhoneFrame } from "@/components/ui/WithPhoneFrame/WithPhoneFrame";
import { useIsRendered } from "@/shared/useIsRendered";

export const PHONE_FRAME_PARAM = "phoneframe";

type PageInPhoneFrameProps = {
  src: string;
  desiredWidth?: number;
  className?: string;
  placeholder?: ReactNode;
};

function addPhoneFrameParam(src: string): string {
  const separator = src.includes("?") ? "&" : "?";
  return `${src}${separator}${PHONE_FRAME_PARAM}`;
}

export function PageInPhoneFrame(props: Readonly<PageInPhoneFrameProps>) {
  return (
    <ClientOnly>
      <PageInPhoneFrameContent {...props} />
    </ClientOnly>
  );
}

function PageInPhoneFrameContent({
  src,
  desiredWidth = 375,
  className,
  placeholder = <div className="size-full bg-white" />,
}: Readonly<PageInPhoneFrameProps>) {
  const srcWithParam = useMemo(() => addPhoneFrameParam(src), [src]);

  const isRendered = useIsRendered();

  return (
    <WithPhoneFrame className={className}>
      {isRendered ? (
        <ScaledIframe
          src={srcWithParam}
          desiredWidth={desiredWidth}
          placeholder={placeholder}
        />
      ) : (
        placeholder
      )}
    </WithPhoneFrame>
  );
}
